import {
  Dialog,
  Button,
  DialogFooter,
  DialogBody,
  DialogHeader
} from '@material-tailwind/react'
import { Link, useLoaderData } from 'react-router-dom'
import { Pill } from '@/shared/components/pill'
import { EmployeeHistoryContractTable } from './tables'
import { list } from '@/router/utils'

export const EmployeeContractHistory = () => {
  const employee = useLoaderData()

  return (
    <Dialog size='xl' className='h-4/5' open={true}>
      <DialogHeader className='pb-0'>Historial de contratos</DialogHeader>

      <DialogBody className='overflow-auto' style={{ height: 'inherit' }}>
        <div className='flex gap-3'>
          <Pill label='Nombre' value={employee.fullName || employee.name} />
          <Pill label='RUT' value={employee.documentNumber} />
          {employee?.contract?.id && (
            <Pill label='Número de contrato' value={employee.contract.id} />
          )}
        </div>
        <EmployeeHistoryContractTable
          employeeContracts={employee?.employeeContracts || []}
        />
      </DialogBody>

      <DialogFooter className='flex gap-3'>
        <Link to={list('employees')}>
          <Button variant='outlined' color='white'>
            Volver
          </Button>
        </Link>
      </DialogFooter>
    </Dialog>
  )
}
